// Configuração da API para UniHospitalar
function resolveBaseUrl() {
  if (typeof window === 'undefined') {
    return 'https://paineladm.unihospitalar.com.br';
  }

  const hostname = window.location.hostname;

  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:3001'; // Desenvolvimento
  }

  if (hostname === 'www.uniteste.cloud' || hostname === 'uniteste.cloud') {
    return 'https://paineladm.uniteste.cloud'; // Homologação
  }

  return 'https://paineladm.unihospitalar.com.br'; // Produção
}

const API_CONFIG = {
    BASE_URL: resolveBaseUrl(),

    // Endpoints principais
    ENDPOINTS: {
      SEND_EMAIL: '/send-email',
      JOBS: '/api/jobs',
      JOB_APPLICATIONS: '/api/job-applications',
      HEALTH: '/health'
    }
  };

  export default API_CONFIG;
